import React from "react";
import { Button, Col, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import isEmpty from "lodash/isEmpty";

export default class PriceSetting extends React.Component {
    constructor(props) {
        super(props);
        this.state = PriceSetting.getDerivedStateFromProps(this.props, {});
    }
    static getDerivedStateFromProps(props, state) {
        const newState = Object.assign({ rate: '', constant: '', minimum: '', maximum: '' }, state);
        ['rate', 'constant', 'minimum', 'maximum'].forEach((prop) => {
            if (props.hasOwnProperty(prop)) {
                newState[prop] = props[prop];
            }
        });
        return newState;
    }
    handleChange = (props) => {
        this.props.onChange(Object.assign(this.state, props), this.props.index);
    };
    profit = (price) => {
        if (price === '') {
            return '';
        }
        price = parseInt(price);
        return Math.floor(((price * (1 + (this.state.rate || 0) / 100)) + (this.state.constant || 0)) * 0.89 - price);
    };

    render = () => {
        const hasMinimum = typeof this.state.minimum === 'number';
        const hasMaximum = typeof this.state.maximum === 'number';
        const hasCriteria = hasMinimum || hasMaximum;
        console.log(`{${this.state.minimum}}`,)
        return <>
            <Form.Group as={Row}>
                <Form.Group as={Col}>
                    <InputGroup>
                        <FormControl placeholder='最低価格' value={this.state.minimum} type='number'
                            onChange={(e) => this.handleChange({ minimum: e.target.value })}
                            name={`user_setting[price_settings][${this.props.index}][minimum]`}
                            isInvalid={(isEmpty(this.state.minimum) || this.state.minimum < 1)}
                            min={1}
                        />
                        <InputGroup.Text>円</InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">
                        1円以上の値を設定してください
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col}>
                    <InputGroup>
                        <FormControl placeholder='最高価格(省略可)' value={this.state.maximum} type='number'
                            onChange={(e) => this.handleChange({ maximum: e.target.value })}
                            name={`user_setting[price_settings][${this.props.index}][maximum]`}
                        />
                        <InputGroup.Text>円</InputGroup.Text>
                    </InputGroup>
                </Form.Group>
                <Form.Group as={Col}>
                    <InputGroup>
                        <FormControl placeholder='係数(必須)' value={this.state.rate} type='number'
                            onChange={(e) => this.handleChange({ rate: e.target.value })}
                            name={`user_setting[price_settings][${this.props.index}][rate]`}
                            min={10}
                        />
                        <InputGroup.Text>%</InputGroup.Text>
                    </InputGroup>
                    {
                        this.state.rate < 10 &&
                        <Form.Control.Feedback type="invalid">
                            10%以下の値は設定出来ません
                        </Form.Control.Feedback>
                    }
                </Form.Group>
                <Form.Group as={Col}>
                    <InputGroup>
                        <FormControl placeholder='定数' value={this.state.constant} type='number'
                            onChange={(e) => this.handleChange({ constant: e.target.value })}
                            name={`user_setting[price_settings][${this.props.index}][constant]`}
                        />
                        <InputGroup.Text>円</InputGroup.Text>
                    </InputGroup>
                </Form.Group>
            </Form.Group>
            <p className='clearfix'>
                {
                    hasCriteria && <span>Amazon販売価格が</span>
                }
                {
                    hasMinimum && <span>{this.state.minimum}円</span>
                }
                {
                    hasCriteria && <span>〜</span>
                }
                {
                    hasMaximum && <span>{this.state.maximum}円</span>
                }
                {
                    hasCriteria && <span>の時、</span>
                }
                <span>{this.props.market}に出品する際、Amazonでの価格に{this.state.rate}%乗せて、{this.state.constant}円足した価格で自動設定する。</span>
                <span className="text-sm">(1件あたり<span className="text-success">{this.profit(this.state.minimum)}〜{this.profit(this.state.maximum)}円</span>の利益)</span>
                <Button variant="danger" className='float-right mt-2' onClick={(e) => this.props.onDelete(this.props.index)}>削除</Button>
            </p>
        </>;
    }
}
